import React from 'react';
import PropTypes from "prop-types";

const GameDateTime = (props) => {

    const buildDateTime = () => {
        if (props.date === undefined && props.date === null && props.date === ''){
            return '';
        }
        else
        {
            const dt = new Date(props.date);
            const current = new Date();
            const seconds = (current - dt) / 1000;

            const m = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];

            if (dt.getDay() === current.getDay() && dt.getDate() === current.getDate() && dt.getMonth() === current.getMonth()) {
                return "Aujourd'hui " + dt.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit'});
            }

            if (seconds < 172801) {
                let yesterday = new Date(current.setDate(current.getDate() - 1));
                if (dt.getDay() === yesterday.getDay() && dt.getDate() === yesterday.getDate() && dt.getMonth() === yesterday.getMonth()) {
                    return "Hier " + dt.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit'});
                }
            }

            let result = dt.getDate();
            if (result === 1)
            {
                result = "1er";
            }

            result = `${result} ${m[dt.getMonth()]} ${dt.getFullYear()} ${dt.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit'})} `;
            return result;
        }
    };

    return (
        <div className={props.dateClassName}>{buildDateTime()}</div>  
    );
}

/* properties :  */
GameDateTime.propTypes = {
    date: PropTypes.string,
    dateClassName: PropTypes.string
};

export default GameDateTime;